import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ButtonsWrapper = styled(FlexRow)<{ alignButtons }>`
    position: relative;
    justify-content: ${({ alignButtons }) => alignButtons};
    z-index: 1;
    margin: 0 -16px;
`;

export const ButtonIcon = styled(SWReactIcons)`
    margin-right: 4px;
`;
